import { Chip } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Label = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: ${colorTokens.text.dark};
`;

export const LocationContainer = styled.div`
  display: flex;

  svg {
    margin-top: 2px;
  }
`;

export const DetailDescription = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 8px;
  background-color: ${colorPalette.blue98};
  padding: 5px 16px;
  border-radius: 4px;
`;

export const RequiredAsterik = styled.span`
  &:after {
    content: '*';
  }
  color: ${colorPalette.red55};
`;

export const MustBeMetLabel = styled(Chip)`
  height: 21px;
  width: 81px !important;
  gap: 0.25rem;
  padding: 0.125rem 0.625rem;
  border-radius: 0.3125rem;

  background-color: ${colorPalette.orange95};
  color: ${colorPalette.orange43};
  border: 1px solid ${colorPalette.orange44};

  .MuiChip-icon {
    margin: 0;
    color: ${colorPalette.orange43};
  }
`;
